import axios from "axios";

export default function updateAdminCompanyGroup({ uuid, groupUuid }) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/admin/${uuid}/company-group`, {
      group_uuid: groupUuid,
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
